import { render, staticRenderFns } from "./exchangeRate.vue?vue&type=template&id=2ffcccfc&scoped=true"
import script from "./exchangeRate.vue?vue&type=script&lang=ts"
export * from "./exchangeRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffcccfc",
  null
  
)

export default component.exports